@if (!chartReady()) {
  <div class="w-full relative">
  <div class="bg-white rounded rounded-xl h-[400px]">
    <chl-loader
      class="!absolute !top-1/2 !left-1/2 -translate-x-1/2 -translate-y-1/2"
    />
  </div>
</div>
} @else {
  <co-chart-card
  [chartHeader]="chartHeader()"
  [cssClass]="cssClass()"
  [filterOptions]="filterOptions()"
  [selectedFilters]="selectedFilters"
  (onFilterChange)="onDropdownChange()"
  [testResult]="testResult()"
 
>
  <!-- begin::Chart-->
  <div chart-content>
    @if (chartOptions.series?.length) {
      <apx-chart
        [series]="chartOptions.series!"
        [chart]="chartOptions.chart!"
        [xaxis]="chartOptions.xaxis!"
        [stroke]="chartOptions.stroke!"
        [tooltip]="chartOptions.tooltip!"
        [dataLabels]="chartOptions.dataLabels!"
        [legend]="chartOptions.legend!"
        [markers]="chartOptions.markers!"
        [grid]="chartOptions.grid!"
        [yaxis]="chartOptions.yaxis!"
        [title]="chartOptions.title!"
      ></apx-chart>
    }
    @if (chartTable().length) {
    <p-table
        [value]="chartTable()"
        [paginator]="true"
        [rows]="5"
        [tableStyle]="{ width: '100%' }"
      >
        <ng-template #header>
          <tr>
            <th>Provider</th>
            <th>Flagged</th>
            <th>Total</th>
            <th>Proportion</th>
            <th>% Flagged</th>
            <th>% Claims</th>
          </tr>
        </ng-template>

        <ng-template #body let-row>
          <tr>
            <td>{{ row.provider }}</td>
            <td>{{ row.flagged }}</td>
            <td>{{ row.total }}</td>
            <td>{{ row.proportion }}</td>
            <td>{{ row.percentageOfPeriodFlagged }}</td>
            <td>{{ row.percentageOfPeriodClaims }}</td>
          </tr>
        </ng-template>
      </p-table>
    }
    @if(!chartTable().length && !chartOptions.series?.length)
    {
    <div class="flex items-center justify-center">
      <span class="text-black-500 text-lg font-medium">{{"REPORTS.NO_DATA_FOUND" | translate}}</span>
    </div>
    }
  </div>


</co-chart-card>
}
